<div class="w-full h-full min-h-full flex flex-col gap-[0.75rem]" [gcElementWidthClass]="{
    'is-small': POPUP_MINIMIZED_WIDTH_SIZE.small,
    'is-middle': POPUP_MINIMIZED_WIDTH_SIZE.middle,
    'is-big': POPUP_MINIMIZED_WIDTH_SIZE.big,
  }"
  #widthClass="gcElementWidthClass">
  @let data = loggerDeployment();
  @let chartDataAvailable = isChartDataExist();
  @let requestError = error();

  @if (data) {
   <div class="flex flex-col [.is-big_&]:flex-row [.is-big_&]:px-[0.75rem] [.is-big_&]:pb-[0.75rem] gap-0 h-full">
    @if (chartDataAvailable) {
      <div class="grow-1 flex max-w-full min-w-0 min-h-0 px-4">
        @let chartCombinedData = combinedChartData();
        <gc-floating-popup-bar-chart-wrapper
          class="grow-1 [.is-big_&]:h-full max-w-full"
          [chartOptions]="chartCombinedData.chartOptions"
          [chartData]="chartCombinedData.chartData"
          [additionalPlugins]="chartPlugins">
        </gc-floating-popup-bar-chart-wrapper>
      </div>
    } @else {
      <div class="grow-1 flex max-w-full min-w-0 min-h-0 px-4 items-center justify-center">
        <gc-floating-popup-base-error-message [isMinimized]="true" [requestError]="requestError"></gc-floating-popup-base-error-message>
      </div>
    }
   </div>
  }
</div>
